import React from "react"
import {observer} from "mobx-react"
import Button from "@material-ui/core/Button"
import Tooltip from "@material-ui/core/Tooltip"

import "./xsButton.less"

export default observer(
	({
		id,
		className,
		disabled,
		icon = "",
		onClick,
		tooltip,
		tabIndex,
		placement,
		delay,
		size = "medium",
		variant = "contained",
		color = "primary"
	}) => {
		if (isSafe(tooltip)) {
			return (
				<Tooltip title={tooltip} enterDelay={delay} placement={placement}>
					<Button
						id={id}
						className={`iconButton ${className}`}
						size={size}
						variant={variant}
						color={color}
						onClick={onClick}
						disabled={disabled}
						style={{minHeight: "40px", minWidth: "40px", width: "40px", height: "40px"}}
						tabIndex={tabIndex}
					>
						{icon}
					</Button>
				</Tooltip>
			)
		} else {
			return (
				<Button
					id={id}
					size={size}
					variant={variant}
					color={color}
					className={`iconButton ${className}`}
					onClick={onClick}
					disabled={disabled}
					style={{minHeight: "40px", minWidth: "40px", width: "40px", height: "40px"}}
					tabIndex={tabIndex}
				>
					{icon}
				</Button>
			)
		}
	}
)
